var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u98DE\\u6868\\u3011\\u6A21\\u578B\\u9009\\u578B\\u53C2\\u6570\\u8F93\\u5165\\u5B8C\\u6210\\u6001",
    transform: "translate(-240.000000, -723.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(240.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13\\u5907\\u4EFD",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0.9996 L2.5,14.9996 L13.5,14.9996 L13.5,5.9996 L9.5,5.9996 L8.5,5.9996 L8.5,5.0006 L8.5,0.9996 L2.5,0.9996 Z M4.5,8.9996 L11.5,8.9996 L11.5,7.9996 L4.5,7.9996 L4.5,8.9996 Z M4.5,10.9996 L8.501,10.9996 L8.501,9.9996 L4.5,9.9996 L4.5,10.9996 Z",
    id: "\\u56FE\\u6807-\\u586B\\u8272",
    fill: "#2932E1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.5,
    fill: "#FFFFFF",
    transform: "translate(11.000600, 3.499600) scale(-1, -1) translate(-11.000600, -3.499600) ",
    points: "8.501 0.9996 13.5002 0.9996 13.5002 5.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    fillOpacity: 0.5,
    fill: "#2932E1",
    transform: "translate(11.000600, 3.499600) scale(-1, -1) translate(-11.000600, -3.499600) ",
    points: "8.501 0.9996 13.5002 0.9996 13.5002 5.9996"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.1bd5c5f0.svg";
export { ForwardRef as ReactComponent };